import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Dumbbell, PlayCircle, TrendingUp, MessageCircle, Calendar, Smartphone, ArrowRight, Check, Apple, Watch, Scale, HeartPulse, Footprints, Activity, Moon, Bike, Flame, Puzzle, Shield, Zap, Heart, Triangle, Youtube, Calendar as CalendarIcon, ClipboardCheck, ClipboardList, MessagesSquare, Sprout } from 'lucide-react';
import { Logo } from '../../Logo';
const TRAINERIZE_URL = 'https://www.trainerize.me/profile/structured/?planGUID=0adc7cc9d3274ca183f4a7ca2a0e16a3';
const fadeUpVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.2, 0.65, 0.3, 0.9]
    }
  }
};
const staggerContainer = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12
    }
  }
};
// Phone mockup component — stylized "Structured" workout UI
function PhoneMockup() {
  return <div className="relative mx-auto w-[280px] md:w-[320px]" data-id="element-3162" data-mp="17gqq7a924ivs">
      {/* Phone frame */}
      <div className="relative bg-charcoal rounded-[3rem] p-3 shadow-2xl border-[3px] border-darkgray" data-id="element-3163" data-mp="12hxb5de4gjti">
        {/* Notch */}
        <div className="absolute top-3 left-1/2 -translate-x-1/2 w-32 h-6 bg-charcoal rounded-b-2xl z-20" data-id="element-3164" data-mp="tjlotnkag86v" />

        {/* Screen */}
        <div className="bg-bodybg rounded-[2.3rem] overflow-hidden aspect-[9/19.5] relative" data-id="element-3165" data-mp="oladt9i9brn2">
          {/* Status bar */}
          <div className="flex justify-between items-center px-6 pt-4 pb-2 text-[10px] text-white" data-id="element-3166" data-mp="js7jgz5noe5t">
            <span className="font-bold" data-id="element-3167" data-mp="eup8l382vov6">9:41</span>
            <span className="opacity-70" data-id="element-3168" data-mp="atdplgjpm1vy">●●●●●</span>
          </div>

          {/* App content */}
          <div className="px-5 py-4" data-id="element-3169" data-mp="5uaizro2znlv">
            {/* Header */}
            <div className="flex items-center justify-between mb-6 pt-4" data-id="element-3170" data-mp="5vlobvx6d3f3">
              <Logo className="w-7 h-7" data-id="element-3171" data-mp="v6c57omq1yp" />
              <span className="text-[8px] font-bold text-[#9A9A90] uppercase tracking-[0.25em]" data-id="element-3172" data-mp="3ncpwh9yh9u4v">
                Structured
              </span>
            </div>

            {/* Greeting */}
            <p className="text-[10px] text-tealslate uppercase tracking-widest mb-1 font-bold" data-id="element-3173" data-mp="3dea5d6zgakvd">
              Today's Workout
            </p>
            <h3 className="text-xl font-serif text-white leading-tight mb-1" data-id="element-3174" data-mp="3ieelux0czfll">
              Upper Body
            </h3>
            <p className="text-[10px] text-[#9CA3AF] mb-5" data-id="element-3175" data-mp="9y1ypxltv25t">
              Week 3 · Day 2 · 45 min
            </p>

            {/* Progress bar */}
            <div className="bg-darkgray h-1 rounded-full overflow-hidden mb-6" data-id="element-3176" data-mp="807wy23b5n7">
              <div className="bg-tealslate h-full w-[35%] rounded-full" data-id="element-3177" data-mp="5w5kkjuaep1" />
            </div>

            {/* Exercise list */}
            <div className="space-y-2" data-id="element-3178" data-mp="svw31yc0gphv">
              {[{
              name: 'Incline DB Press',
              sets: '4 × 8',
              done: true
            }, {
              name: 'Cable Row',
              sets: '4 × 10',
              done: true
            }, {
              name: 'Lat Pulldown',
              sets: '3 × 12',
              done: false,
              active: true
            }, {
              name: 'Lateral Raise',
              sets: '3 × 15',
              done: false
            }, {
              name: 'Tricep Pushdown',
              sets: '3 × 12',
              done: false
            }].map((ex, i) => <div key={i} className={`flex items-center gap-3 p-2.5 rounded ${ex.active ? 'bg-tealslate/20 border-l-2 border-tealslate' : ex.done ? 'bg-navyslate/30 opacity-60' : 'bg-navyslate/30'}`} data-id="element-3179" data-mp="28gx1gol2as22" data-mpi={i}>
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center shrink-0 ${ex.done ? 'bg-tealslate' : 'border border-[#9CA3AF]'}`} data-id="element-3180" data-mp="3ftglxde8jpe8">
                    {ex.done && <Check className="w-3 h-3 text-white" data-id="element-3181" data-mp="iyjc41swub7a" />}
                  </div>
                  <div className="flex-1 min-w-0" data-id="element-3182" data-mp="nynslrttj5xi">
                    <p className="text-[10px] font-bold text-white truncate" data-id="element-3183" data-mp="nx2yu4fbvr0p">
                      {ex.name}
                    </p>
                    <p className="text-[8px] text-[#9CA3AF]" data-id="element-3184" data-mp="xwk1se373qsz">{ex.sets}</p>
                  </div>
                  {ex.active && <PlayCircle className="w-4 h-4 text-tealslate shrink-0" data-id="element-3185" data-mp="11xdudkrl1ts7" />}
                </div>)}
            </div>

            {/* CTA at bottom */}
            <div className="mt-5 bg-tealslate text-center py-3 rounded" data-id="element-3186" data-mp="1boi4o76bcqgp">
              <p className="text-[10px] font-bold text-white uppercase tracking-widest" data-id="element-3187" data-mp="1gn1tcfcakgcr">
                Continue Workout
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Glow effect */}
      <div className="absolute inset-0 bg-tealslate/10 blur-3xl -z-10" data-id="element-3188" data-mp="364qc2n9o4db0" />
    </div>;
}
export function Training() {
  return <div className="w-full min-h-screen bg-bodybg" data-id="element-3189" data-mp="314b122cuzhw7">
      <span id="top" className="block" aria-hidden="true" data-id="element-3190" data-mp="2w610fc8d7p37" />
      {/* VIDEO HERO */}
      <section className="relative w-full min-h-[426px] md:h-[426px] overflow-hidden bg-black px-6 pt-[59px]" data-id="element-3191" data-mp="2w7ual1i6srfy">
        <div className="relative h-full w-full mx-auto" data-id="element-3192" data-mp="3ouorjofsp8oo">
          <video src="https://file.trainerize.com/assets/tz/home/videos/app-features-v2.mp4" autoPlay muted loop playsInline preload="metadata" className="absolute inset-0 w-full h-full object-cover" data-id="element-3193" data-mp="3ou5diit9n4fx" />
          {/* Dark overlay for text legibility */}
          <div className="absolute inset-0 bg-black/60 pointer-events-none" data-id="element-3194" data-mp="bfigs3s9jnv0" />

          {/* Overlay content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6" data-id="element-3195" data-mp="6ok0333d4nr8">
            <motion.h2 initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="text-4xl md:text-6xl lg:text-7xl font-serif text-white leading-[1.05] max-w-4xl" data-id="element-3196" data-mp="20wns3oxm8eth">
              Train smarter. Anywhere.
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="text-base md:text-lg text-white/85 max-w-xl mt-5 leading-relaxed" data-id="element-3197" data-mp="1m89qfhbxqwei">
              A coach in your pocket — workouts, tracking, and progress, all in
              one app.
            </motion.p>
          </div>
        </div>
      </section>

      {/* VALUE PROPS STRIP */}
      <section className="bg-white py-14 md:py-16 px-6" data-id="element-3198" data-mp="qzz6nvb1dchj">
        <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10 md:gap-8 text-center" data-id="element-3199" data-mp="15ntzrcsyhiv5">
          {[{
          icon: ClipboardList,
          title: 'Programmed Workouts',
          desc: 'Training tailored to your goals and schedule.'
        }, {
          icon: TrendingUp,
          title: 'Evidence-Based',
          desc: 'Built on exercise science, not gym myths.'
        }, {
          icon: HeartPulse,
          title: 'Sustainable Progress',
          desc: 'Strength gains that outlast the program.'
        }, {
          icon: MessagesSquare,
          title: 'Coach Support',
          desc: 'Direct access to a coach who answers.'
        }].map((item, i) => <div key={i} className="flex flex-col items-center" data-id="element-3200" data-mp="2zmkhe3faxkf5" data-mpi={i}>
              <item.icon className="w-6 h-6 text-[#3B4A4F] mb-4" strokeWidth={1.5} data-id="element-3201" data-mp="34kvsehhc20yy" />
              <h3 className="text-lg font-serif font-bold text-[#3B4A4F] mb-2" data-id="element-3202" data-mp="39bc682p2folu">
                {item.title}
              </h3>
              <p className="text-sm text-[#3B4A4F] leading-relaxed max-w-[200px]" data-id="element-3203" data-mp="3ea5lo0nwxpon">
                {item.desc}
              </p>
            </div>)}
        </div>
      </section>

      {/* HERO */}
      <section className="bg-bodybg pt-16 pb-10 md:pb-14 px-6 border-b border-darkgray relative overflow-hidden" data-id="element-3204" data-mp="2lm9qj0dzs5tz">
        {/* Background image — dark grunge texture */}
        <div className="absolute inset-0 bg-cover bg-center pointer-events-none" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/jnhsHXXgzHt8i7RDXcnHjm/pasted-image.jpg)'
      }} data-id="element-3205" data-mp="2unr2c6kd9lcv" />
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-tealslate/5 rounded-full blur-3xl pointer-events-none" data-id="element-3206" data-mp="1uere222emgqn" />

        <div className="max-w-7xl mx-auto relative z-10" data-id="element-3207" data-mp="1lm7mtmofzefu">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3208" data-mp="1lkmqbrikhlfc">
            {/* Left: Pitch */}
            <motion.div initial="hidden" animate="visible" variants={staggerContainer} data-id="element-3209" data-mp="1gmuq8a7rqt02">
              <motion.h1 variants={fadeUpVariants} className="text-4xl md:text-6xl font-serif text-white leading-[1.05] mb-6" data-id="element-3210" data-mp="16of9902gh04a">
                Structured training. Built for the way you live now.
              </motion.h1>
              <motion.div variants={fadeUpVariants} className="w-12 h-0.5 bg-tealslate mb-6" data-id="element-3211" data-mp="xqldbq8ls8hn" />
              <motion.p variants={fadeUpVariants} className="text-base md:text-lg text-[#D8D8D0] leading-relaxed mb-10 max-w-xl" data-id="element-3212" data-mp="2s206kh0toq25">
                Programmed workouts designed to preserve muscle, build strength,
                and maximize the results of your GLP-1 journey, delivered
                through a coach-built training app.
              </motion.p>

              {/* Price */}
              <motion.div variants={fadeUpVariants} className="flex items-baseline gap-3 mb-8" data-id="element-3213" data-mp="1q9zkqplbr3u4">
                <span className="text-5xl md:text-6xl font-serif text-white" data-id="element-3214" data-mp="yia7d5qwf5x5">
                  $6.99
                </span>
                <span className="text-sm text-[#9CA3AF] uppercase tracking-widest" data-id="element-3215" data-mp="1cagp2w9p9kyp">
                  / month
                </span>
              </motion.div>

              {/* CTAs */}
              <motion.div variants={fadeUpVariants} className="flex flex-col sm:flex-row gap-4" data-id="element-3216" data-mp="jschmldbm85u">
                <a href={TRAINERIZE_URL} target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-tealslate text-white text-sm font-bold uppercase tracking-wider hover:bg-lightteal transition-colors text-center inline-flex items-center justify-center gap-2" data-id="element-3217" data-mp="etrikp9t1uiz">
                  Start Your Program <ArrowRight className="w-4 h-4" data-id="element-3218" data-mp="2mgku2l2qnsuc" />
                </a>
                <a href="#whats-included" className="px-8 py-4 border border-[#D8D8D0] text-[#D8D8D0] text-sm font-bold uppercase tracking-wider hover:bg-white/10 transition-colors text-center" data-id="element-3219" data-mp="3a4u6wxhz569c">
                  What's Included
                </a>
              </motion.div>

              <motion.p variants={fadeUpVariants} className="text-xs text-[#7A7A70] italic mt-6" data-id="element-3220" data-mp="354zm9boslcwq">
                Cancel anytime · No long-term commitment
              </motion.p>
            </motion.div>

            {/* Right: Phone mockup */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9,
            y: 30
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            duration: 1,
            delay: 0.3,
            ease: [0.2, 0.65, 0.3, 0.9]
          }} className="flex justify-center" data-id="element-3221" data-mp="19npsldt9qd4z">
              <img src="https://cdn.magicpatterns.com/uploads/5rm9yb4s15WyVS6g5EYh3Q/pasted-image.webp" alt="Structured training program in the ABC Trainerize app" className="w-[280px] md:w-[340px] h-auto drop-shadow-2xl" data-id="element-3222" data-mp="lyx607yjdhn1" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* MEAL TRACKING VISUAL */}
      <section className="bg-white py-16 md:py-24 px-6" data-id="element-3223" data-mp="27d18e51gg1hi">
        <div className="max-w-7xl mx-auto flex justify-center" data-id="element-3224" data-mp="27djcfnuczjzz">
          <img src="https://cdn.magicpatterns.com/uploads/6WN21WJ1kjcjz47Ue6HQVC/image.png" alt="Meal tracking inside the Structured training app — photo food journaling, full nutrition tracking, and custom recipes" className="w-full h-auto" data-id="element-3225" data-mp="2ex2bf3jzznu7" />
        </div>
      </section>

      {/* INTEGRATIONS — LEVEL UP YOUR PROGRESS */}
      <section className="bg-[#F7F8FB] py-10 md:py-14 px-6" data-id="element-3226" data-mp="1vxofwh6me51l">
        <div className="max-w-7xl mx-auto" data-id="element-3227" data-mp="1vz9b890rds0i">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3228" data-mp="20w9kstwthcwd">
            {/* Left */}
            <div data-id="element-3229" data-mp="25vclk25rkwyj">
              <p className="text-xs md:text-sm font-bold text-tealslate uppercase tracking-[0.25em] mb-6" data-id="element-3230" data-mp="25ut74vfboqp9">
                Integrations
              </p>
              <h2 className="text-5xl md:text-6xl font-bold text-[#0B1B3A] leading-[1.02] tracking-tight mb-6" data-id="element-3231" data-mp="3hb1av06hq82i">
                Level up your <span className="text-tealslate" data-id="element-3232" data-mp="3lbl4vuvrovkf">progress.</span>
              </h2>
              <p className="text-base md:text-lg text-[#5A6478] leading-relaxed max-w-md mb-8" data-id="element-3233" data-mp="3junu5je2kw1c">
                Effortlessly connect ABC Trainerize with the world's most
                powerful apps to level up your fitness and track what matters
                most.
              </p>
              <span className="inline-flex items-center gap-2 text-black text-sm font-bold" data-id="element-3234" data-mp="3ouk0vqe5j1kl">
                See all integrations <ArrowRight className="w-4 h-4" data-id="element-3235" data-mp="6o5qu2j07brh" />
              </span>
            </div>

            {/* Right: integration tile grid */}
            <div className="grid grid-cols-3 sm:grid-cols-5 gap-3 md:gap-4" data-id="element-3236" data-mp="1p1dczp1qrvc">
              {[{
              label: 'Apple',
              icon: <svg viewBox="0 0 24 24" className="w-8 h-8" fill="#000000" aria-hidden="true" data-id="element-3237" data-mp="bgfa4zpm5dks">
                      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" data-id="element-3238" data-mp="leuyww164ar4" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Health Connect',
              icon: <svg viewBox="0 0 48 48" className="w-9 h-9" fill="none" aria-hidden="true" data-id="element-3239" data-mp="l9jgbmt7vkyb">
                      <path d="M24 41C18 36 9 30 9 21a9 9 0 0 1 15-6.7" stroke="#1A4DCB" strokeWidth="5" strokeLinecap="round" fill="none" data-id="element-3240" data-mp="gc9knpf8id21" />
                      <path d="M24 41c6-5 15-11 15-20a9 9 0 0 0-15-6.7" stroke="#4D8DFF" strokeWidth="5" strokeLinecap="round" fill="none" data-id="element-3241" data-mp="7do2vwhl722b" />
                      <circle cx="24" cy="22" r="2.4" fill="#1A4DCB" data-id="element-3242" data-mp="208p2xrduk6h8" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Prism',
              icon: <svg viewBox="0 0 48 48" className="w-9 h-9" aria-hidden="true" data-id="element-3243" data-mp="2nyb3oj9vatrc">
                      <defs data-id="element-3244" data-mp="2j0rnhdtm06wr">
                        <linearGradient id="prismGrad" x1="0" y1="0" x2="1" y2="1" data-id="element-3245" data-mp="2e0dffvs0cwyq">
                          <stop offset="0%" stopColor="#FF7A59" data-id="element-3246" data-mp="12j3xjdoj2czj" />
                          <stop offset="55%" stopColor="#E94B7B" data-id="element-3247" data-mp="shjg09qt5mkp" />
                          <stop offset="100%" stopColor="#7B4BFF" data-id="element-3248" data-mp="xfup2i9a3t1v" />
                        </linearGradient>
                      </defs>
                      <path d="M24 6 L42 40 L6 40 Z" fill="url(#prismGrad)" data-id="element-3249" data-mp="12eo1e7ctxe0g" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Fitbit',
              icon: <div className="grid grid-cols-5 gap-[3px]" data-id="element-3250" data-mp="1b9lylqn0fcxl">
                      {[[0, 0, 1, 0, 0], [0, 1, 1, 1, 0], [1, 1, 1, 1, 1], [0, 1, 1, 1, 0], [0, 0, 1, 0, 0]].flat().map((on, i) => <span key={i} className={`w-1.5 h-1.5 rounded-full ${on ? 'bg-[#00B0B9]' : 'bg-transparent'}`} data-id="element-3251" data-mp="3mz532qnbaevc" data-mpi={i} />)}
                    </div>,
              bg: 'bg-white'
            }, {
              label: 'Zapier',
              icon: <svg viewBox="0 0 48 48" className="w-9 h-9" fill="#FF4F00" aria-hidden="true" data-id="element-3252" data-mp="22erm3ruf9red">
                      {Array.from({
                  length: 6
                }).map((_, i) => <rect key={i} x="22" y="6" width="4" height="36" rx="2" transform={`rotate(${i * 30} 24 24)`} data-id="element-3253" data-mp="1nqdbguqrkyn9" data-mpi={i} />)}
                      <circle cx="24" cy="24" r="4" fill="#FFFFFF" data-id="element-3254" data-mp="2v35mufcwb1tm" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'YouTube',
              icon: <svg viewBox="0 0 48 36" className="w-10 h-7" aria-hidden="true" data-id="element-3255" data-mp="2spa3fpx1w6sw">
                      <rect x="0" y="0" width="48" height="36" rx="8" fill="#FF0000" data-id="element-3256" data-mp="3ldfromnbcdxh" />
                      <path d="M20 11 L34 18 L20 25 Z" fill="#FFFFFF" data-id="element-3257" data-mp="3bmuwzaarftju" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Growth',
              icon: <span className="text-[#1FB07A] font-extrabold text-2xl leading-none" data-id="element-3258" data-mp="cxmb67szf2gf">
                      G
                    </span>,
              bg: 'bg-white'
            }, {
              label: 'TrueCoach',
              icon: <div className="w-9 h-9 rounded-full border-[2.5px] border-black flex items-center justify-center" data-id="element-3259" data-mp="1usx56actvus3">
                      <span className="text-black font-extrabold text-[11px] tracking-tight" data-id="element-3260" data-mp="1zrgr4arf96kg">
                        TC
                      </span>
                    </div>,
              bg: 'bg-white'
            }, {
              label: 'MyFitnessPal',
              icon: <svg viewBox="0 0 48 48" className="w-9 h-9" fill="#1F6BFF" aria-hidden="true" data-id="element-3261" data-mp="1bvm72t2xn7e8">
                      <circle cx="24" cy="8" r="3.5" data-id="element-3262" data-mp="368vk2uuotb18" />
                      <path d="M24 12 L24 26 M24 18 L13 24 M24 18 L35 24 M24 26 L15 42 M24 26 L33 42" stroke="#1F6BFF" strokeWidth="3.5" strokeLinecap="round" fill="none" data-id="element-3263" data-mp="3b7owsl25gy0c" />
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Trainerize Me',
              icon: <div className="w-9 h-9 rounded-full bg-black flex items-center justify-center" data-id="element-3264" data-mp="1i9icppc4bhwk">
                      <Zap className="w-5 h-5 text-white fill-white" data-id="element-3265" data-mp="1dc01fsamoqle" />
                    </div>,
              bg: 'bg-white'
            }, {
              label: 'Apple Health',
              icon: <Heart className="w-8 h-8 text-[#FF3B5C] fill-[#FF3B5C]" data-id="element-3266" data-mp="1n7bkunwzelzh" />,
              bg: 'bg-white'
            }, {
              label: 'Stripe',
              icon: <span className="text-[#635BFF] font-extrabold text-2xl italic leading-none" data-id="element-3267" data-mp="ik0rar6lg4uk">
                      S
                    </span>,
              bg: 'bg-white'
            }, {
              label: 'Google Calendar',
              icon: <svg viewBox="0 0 36 36" className="w-8 h-8" aria-hidden="true" data-id="element-3268" data-mp="wjjy9gno5a5a">
                      <rect x="0" y="0" width="36" height="36" rx="4" fill="#FFFFFF" stroke="#E0E0E0" data-id="element-3269" data-mp="15jyjyh4jor9b" />
                      <rect x="0" y="0" width="36" height="6" fill="#4285F4" data-id="element-3270" data-mp="1k8utkim92cc1" />
                      <rect x="0" y="30" width="36" height="6" fill="#34A853" data-id="element-3271" data-mp="1k6rtf5rdv2tl" />
                      <rect x="30" y="6" width="6" height="24" fill="#FBBC04" data-id="element-3272" data-mp="1p8h42kap1eh5" />
                      <rect x="0" y="6" width="6" height="24" fill="#EA4335" data-id="element-3273" data-mp="39r1dm1l5bdp2" />
                      <text x="18" y="24" textAnchor="middle" fontSize="13" fontWeight="700" fill="#4285F4" fontFamily="Arial, sans-serif" data-id="element-3274" data-mp="34qdpbnoaxayj">
                        31
                      </text>
                    </svg>,
              bg: 'bg-white'
            }, {
              label: 'Acuity Scheduling',
              icon: <span className="text-black font-extrabold text-2xl tracking-tight leading-none" data-id="element-3275" data-mp="3drlcpapa4rdu">
                      A
                    </span>,
              bg: 'bg-white'
            }].map((item, i) => <div key={i} className="flex flex-col items-center text-center" data-id="element-3276" data-mp="a9bkypp9vb2z" data-mpi={i}>
                  <div className={`w-full aspect-square rounded-2xl shadow-sm border border-[#EAECF1] flex items-center justify-center ${item.bg} mb-2`} data-id="element-3277" data-mp="3qx7qz7vfk8ae">
                    {item.icon}
                  </div>
                  <span className="text-[10px] md:text-[11px] text-[#5A6478] leading-tight" data-id="element-3278" data-mp="3h2fwwe1243kd">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>

          {/* Feature row */}
          <div className="mt-16 md:mt-20 bg-white border border-[#EAECF1] rounded-2xl p-8 md:p-10 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12" data-id="element-3279" data-mp="iheceyknt6vz">
            {[{
            icon: Puzzle,
            title: 'Seamless Connections',
            desc: 'Integrations that sync your data and save you time.'
          }, {
            icon: Shield,
            title: 'Trusted Partners',
            desc: 'Connect with industry-leading apps you already use.'
          }, {
            icon: Zap,
            title: 'Track What Matters',
            desc: 'Unify your data, stay consistent, and reach your goals faster.'
          }].map((f, i) => <div key={i} className="flex items-start gap-4" data-id="element-3280" data-mp="2qq2mged06pqo" data-mpi={i}>
                <div className="w-12 h-12 rounded-full bg-[#3B4A4F]/10 flex items-center justify-center flex-shrink-0" data-id="element-3281" data-mp="2qqul5y1wd3l6">
                  <f.icon className="w-5 h-5 text-[#3B4A4F]" data-id="element-3282" data-mp="232bcviiukqt3" />
                </div>
                <div data-id="element-3283" data-mp="1y389s3mfgunr">
                  <h3 className="text-base font-bold text-[#3B4A4F] mb-1" data-id="element-3284" data-mp="2c16iothzbyvv">
                    {f.title}
                  </h3>
                  <p className="text-sm text-[#3B4A4F] leading-relaxed" data-id="element-3285" data-mp="27zbjbujlzvkq">
                    {f.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* FINAL CTA — Free Trial Email Capture */}
      <section className="relative bg-black py-24 md:py-32 px-6 text-center overflow-hidden" data-id="element-3286" data-mp="2g3t1wqapk5fv">
        {/* Subtle diagonal accent stripes */}
        <div className="absolute inset-0 opacity-[0.06] pointer-events-none" style={{
        backgroundImage: 'repeating-linear-gradient(115deg, transparent 0 220px, #ffffff 220px 320px, transparent 320px 540px)'
      }} data-id="element-3287" data-mp="2l1ui93gr1qnn" />
        <div className="relative max-w-3xl mx-auto" data-id="element-3288" data-mp="1xduv0dincidt">
          <h2 className="text-4xl md:text-6xl font-normal text-white leading-tight tracking-tight mb-6" data-id="element-3289" data-mp="1xb8cxjy4qkhc">
            Start your <span className="text-[#FACC15]" data-id="element-3290" data-mp="22a1v3pod2znu">free 30-day trial</span>
          </h2>
          <p className="text-sm md:text-base font-bold text-white/90 uppercase tracking-[0.2em] mb-10" data-id="element-3291" data-mp="26bwqyeniwku8">
            And build muscle with a plan.
          </p>

          <div className="flex flex-col sm:flex-row items-stretch max-w-2xl mx-auto border-2 border-[#FACC15] overflow-hidden" data-id="element-3292" data-mp="1elscsxqcwu1g">
            <div className="flex-1 bg-black text-white px-6 py-4 text-base tracking-[0.2em] uppercase flex items-center justify-center sm:justify-start" data-id="element-3293" data-mp="1imm0pr3su8uc">
              Use Code: ONEMONTH
            </div>
            <a href={TRAINERIZE_URL} target="_blank" rel="noopener noreferrer" className="bg-[#FACC15] hover:bg-[#EAB308] text-black text-base font-bold px-8 py-4 transition-colors whitespace-nowrap inline-flex items-center justify-center" data-id="element-3294" data-mp="163qc5ivwmjtu">
              Get started
            </a>
          </div>

          <p className="text-sm text-white/70 italic mt-6" data-id="element-3295" data-mp="nea7qkh3m785">
            Enjoy 30 days free with unlimited access.
          </p>
        </div>
      </section>
    </div>;
}